import TacticsPage from "../../../products/strategy_tool/TacticsPage";
import UserHoldingsPage from "../../../products/user_holdings/UserHoldingsPage";
import CompanionRoomPage from "../../../products/companion_room/CompanionRoomPage";
import IntelligenceFeedPage from "../../../products/intel/IntelligenceFeedPage";
import ViewpointFeedPage from "../../../products/viewpoint/ViewpointFeedPage";
import FollowPoolPage from "../../../products/follow_pool/FollowPoolPage";
import ConceptPage from "../../../products/concept/ConceptPage";
import InstHotspotPage from "../../../products/inst_hotspot/InstHotspotPage";
import MyNotesPage from "../../../products/my_notes/MyNotesPage";
import { MY_NOTES_ROUTE_KEY } from "../SpaceModel";
import { normalizeIntelCommentKind } from "../SpaceType";
import type { MembershipProduct, SpaceProfile } from "../SpaceType";
import { SpaceModuleSubscribeGate } from "./SpaceModuleSubscribeGate";
import { SpaceModuleSubscribedSoon } from "./SpaceModuleSubscribedSoon";

export function SpaceProductSection(props: {
  spaceId: string;
  sectionKey: string;
  module: MembershipProduct | null;
  spaceProfile: SpaceProfile | null;
  isLoggedIn: boolean;
  onLoginRequest: () => void;
}): JSX.Element {
  const { spaceId, sectionKey, module, spaceProfile, isLoggedIn, onLoginRequest } = props;

  if (sectionKey === MY_NOTES_ROUTE_KEY) {
    return <MyNotesPage spaceId={spaceId} />;
  }

  if (!module) {
    return <div className="space-section-placeholder" />;
  }

  if (!module.userSubscribed) {
    return (
      <SpaceModuleSubscribeGate
        spaceId={spaceId}
        row={module}
        isLoggedIn={isLoggedIn}
        onLoginRequest={onLoginRequest}
        spaceProfile={spaceProfile}
      />
    );
  }

  switch (module.productKind) {
    case "group_companion":
      return (
        <CompanionRoomPage
          spaceId={spaceId}
          spaceProductId={module.spaceProductId}
          productDisplayName={module.displayName}
          spaceDisplayName={spaceProfile?.name?.trim()}
          membershipDaysRemaining={module.daysRemaining}
          subscribeHomePath={`/space/${spaceId}/home`}
        />
      );
    case "intel":
      return (
        <IntelligenceFeedPage
          spaceId={spaceId}
          spaceProductId={module.spaceProductId}
          spaceDisplayName={spaceProfile?.name?.trim() || "本空间"}
          intelCommentKind={normalizeIntelCommentKind(module.intelCommentKind)}
        />
      );
    case "viewpoint":
      return (
        <ViewpointFeedPage
          spaceId={spaceId}
          spaceProductId={module.spaceProductId}
          spaceDisplayName={module.displayName?.trim() || ""}
        />
      );
    case "user_holdings":
      return <UserHoldingsPage spaceId={spaceId} />;
    case "follow_pool":
      return (
        <FollowPoolPage
          spaceId={spaceId}
          spaceProductId={module.spaceProductId}
        />
      );
    case "concept":
      return (
        <ConceptPage
          spaceId={spaceId}
          spaceProductId={module.spaceProductId}
        />
      );
    case "inst_hotspot":
      return (
        <InstHotspotPage
          spaceId={spaceId}
          spaceProductId={module.spaceProductId}
        />
      );
    case "strategy_tool":
      return (
        <TacticsPage
          spaceId={spaceId}
          spaceProductId={module.spaceProductId}
        />
      );
    default:
      return <SpaceModuleSubscribedSoon spaceProfile={spaceProfile} />;
  }
}
